<template>
  <div>
    <div id="panels" class="relative w-[100hw] overflow-hidden z-50"></div>

    <AuthLoginPage v-if="!authorizedUser && routeNeedAuth"/>
    <router-view v-if="!authorizedUser && !routeNeedAuth" />

    <div v-if="authorizedUser" class="flex flex-row w-[100hw] main-container z-10">
      <LeftSide/>
      <div class="flex-1/3 relative">
        <header class="flex">
          <div class="flex-1/5 basis-200 px-4 py-3 sm:px-2 lg:px-2">
            <h1 class="w-0 text-nowrap text-1xl font-bold text-gray-200 sm:px-2 lg:px-2">{{ routeTitle }}</h1>
          </div>
          <div class="flex-3/5 py-1"></div>
          <div class="flex-1/5 py-2 px-10">
            <div class="flex text-nowrap text-gray-400">
              <TopDemo></TopDemo>
              <TopBalance></TopBalance>
              <TopUserProfile></TopUserProfile>
            </div>
          </div>
        </header>
        <div id="app-content" class="block relative overflow-x-hidden bg-gray-700">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftSide from "@/components/LeftSide.vue"
import TopUserProfile from "@/components/TopUserProfile.vue"
import TopBalance from "@/components/TopBalance.vue"
import TopDemo from "@/components/TopDemo.vue"
import AuthLoginPage from "@/page/AuthLoginPage.vue"
import store from '@/store.js'
import { useRoute } from 'vue-router'

export default {
  name: 'App',
  components: {LeftSide, TopBalance, TopDemo, TopUserProfile, AuthLoginPage},
  data() {
    return {
      store,
      route: useRoute()
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || 'AppLog Console';
      }
    },
  },
  computed: {
    authorizedUser: function() {
      return this.store.getters.isAuthorized
    },
    routeNeedAuth: function() {
      return this.route.meta?.offAuth !== true;
    },
    routeTitle: function() {
      return this.route.meta?.title;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #5a6d80;
  margin-top: 0;
  min-height: 100vh;
  background-color: rgb(33, 45, 51);
}

.main-container {
  height: calc(100vh - 20px);
  box-sizing: border-box;
  padding-bottom: 20px;
}

#app-content {
  height: calc(100vh - 48px);
  padding-bottom: 20px;
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 20px;
}
</style>
